import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import $ from 'jquery';
import { assetUrl } from '../../config';
import AutoVideo from '../AutoVideo';
import { loadScripts } from '../../loadScript';
import { Rich, withT } from '../../i18n';

// The landing page.
//
// Deliberately short. Kanosei takes no inbound, publishes no holdings and
// manages no social accounts, so a page structured like a fund's — thesis,
// sectors, portfolio, pitch us — would be four sections of throat-clearing
// around nothing. What is left is the one thing that is genuinely ours and
// does not go stale: the collection. It carries the page, and the copy stays
// out of its way.
//
// Nothing here claims a fund size, a stage, a cheque size, a track record or a
// date. None of that has been given to us, and a page that invents its own
// terms is worse than one that omits them.

class Home extends Component {
    clickMenu() {
        $('#page-loader').show();
        window.scrollTo(0, 0);
        setTimeout(function () { $('#page-loader').fadeOut(1500); }, 3000);
        $('.qodef-follow-info-holder').remove();
        $('body').removeClass('sidebar_active');
    }

    componentDidMount() {
        // video_control.js binds the hero's sound toggle. amoli-core.js is no
        // longer needed here: it drove the sticky nav on the artwork grid, and
        // that grid has moved to the collection carousel.
        loadScripts(['/assets/js/video_control.js'])
            .catch((err) => console.error('[home] legacy scripts failed:', err));
    }

    render() {
        const { t } = this.props;
        return (
            <main className="home">
                <section className="sticky__hero vidSec">
                    <AutoVideo
                        src={assetUrl('home/PrifmaHome.mp4')}
                        poster={assetUrl('home/PrifmaHome-poster.jpg')}
                    />

                    <div className="sound_toggle">
                        <svg aria-hidden="true" focusable="false" data-prefix="fas" data-icon="volume-up" role="img" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512" className="svg-inline--fa fa-volume-up fa-w-18"><path fill="#fff" d="M215.03 71.05L126.06 160H24c-13.26 0-24 10.74-24 24v144c0 13.25 10.74 24 24 24h102.06l88.97 88.95c15.03 15.03 40.97 4.47 40.97-16.97V88.02c0-21.46-25.96-31.98-40.97-16.97zm233.32-51.08c-11.17-7.33-26.18-4.24-33.51 6.95-7.34 11.17-4.22 26.18 6.95 33.51 66.27 43.49 105.82 116.6 105.82 195.58 0 78.98-39.55 152.09-105.82 195.58-11.17 7.32-14.29 22.34-6.95 33.5 7.04 10.71 21.93 14.56 33.51 6.95C528.27 439.58 576 351.33 576 256S528.27 72.43 448.35 19.97zM480 256c0-63.53-32.06-121.94-85.77-156.24-11.19-7.14-26.03-3.82-33.12 7.46s-3.78 26.21 7.41 33.36C408.27 165.97 432 209.11 432 256s-23.73 90.03-63.48 115.42c-11.19 7.14-14.5 22.07-7.41 33.36 6.51 10.36 21.12 15.14 33.12 7.46C447.94 377.94 480 319.54 480 256zm-141.77-76.87c-11.58-6.33-26.19-2.16-32.61 9.45-6.39 11.61-2.16 26.2 9.45 32.61C327.98 228.28 336 241.63 336 256c0 14.38-8.02 27.72-20.92 34.81-11.61 6.41-15.84 21-9.45 32.61 6.43 11.66 21.05 15.8 32.61 9.45 28.23-15.55 45.77-45 45.77-76.88s-17.54-61.32-45.78-76.86z" className=""></path></svg>
                    </div>

                    <div className="sticky__hero_inner">
                        <h1 className="hero__heading">{t('nav.tagline')}</h1>
                        <p className="hero__sub">{t('home.heroSub')}</p>
                        <div className="hero__actions">
                            <Link onClick={() => this.clickMenu()} to="/collection" className="css_btn view__more">
                                <span>{t('home.viewCollection')}</span>
                            </Link>
                        </div>
                    </div>

                    <Link
                        onClick={() => this.clickMenu()}
                        to="/portfolio-item/prifma-luminosos"
                        className="author_name"
                    >
                        <h2>prifma.luminosos</h2>
                        <span>GMUNK</span>
                    </Link>
                </section>

                {/* Reuses .thesis__sec rather than introducing a class of its
                    own — the section it replaces sat in exactly this position
                    and the styling is unchanged. */}
                <section className="thesis__sec">
                    <div className="wrapper">
                        <div className="thesis__inner">
                            <h2 className="heading styled">
                                <Rich text={t('home.thesisHeading')} />
                            </h2>
                            <div className="desc">
                                <p>{t('home.thesisP1')}</p>
                                <p>{t('home.thesisP2')}</p>
                            </div>
                        </div>
                    </div>
                </section>

                <section className="collection__teaser">
                    <AutoVideo
                        src={assetUrl('home/TheLastShawarma.mp4')}
                        poster={assetUrl('home/TheLastShawarma-poster.jpg')}
                    />
                    <div className="collection__teaser_inner">
                        <h3 className="section__label">{t('home.collectionLabel')}</h3>
                        <h2 className="heading styled">{t('home.collectionHeading')}</h2>
                        <Link onClick={() => this.clickMenu()} to="/collection" className="css_btn">
                            <span>{t('home.viewCollection')}</span>
                        </Link>
                    </div>
                    <Link
                        onClick={() => this.clickMenu()}
                        to="/portfolio-item/the-last-shawarma"
                        className="author_name"
                    >
                        <h2>The Last Shawarma</h2>
                        <span>Bosslogic</span>
                    </Link>
                </section>
            </main>
        );
    }
}

export default withT(Home);
